import { createSlice, PayloadAction } from '@reduxjs/toolkit';
// Import Types
import type { SubscriptionPlan } from 'types';

export interface SubscriptionPlansState {
    isLoading: boolean;
    list: SubscriptionPlan[];
}

export const initialState: SubscriptionPlansState = {
    isLoading: false,
    list: [],
};

export const subscriptionPlansSlice = createSlice({
    name: 'subscriptionPlans',
    initialState,
    reducers: (create) => ({
        getSubscriptionPlansFetch: create.reducer((state) => {
            state.isLoading = true;
        }),
        getSubscriptionPlansSucceeded: create.reducer((state, { payload }: PayloadAction<SubscriptionPlan[]>) => {
            state.isLoading = false;
            state.list = payload;
        }),
        getSubscriptionPlansFailed: create.reducer((state) => {
            state.isLoading = false;
        }),
    }),
    selectors: {
        selectSubscriptionPlansData: (subscriptionPlans) => subscriptionPlans,
        selectSubscriptionPlans: (subscriptionPlans) => subscriptionPlans.list,
    },
});

export const { getSubscriptionPlansFetch, getSubscriptionPlansSucceeded, getSubscriptionPlansFailed } =
    subscriptionPlansSlice.actions;
export const { selectSubscriptionPlansData, selectSubscriptionPlans } = subscriptionPlansSlice.selectors;
